
<div class="main_entry">
  <div class="the_entry"
  *ngFor="let lessorInfo of lessorInfos"
  (click)="onView(lessorInfo)"
  style="cursor: pointer; display: block;padding:0 1.5rem;"
  >
    <!-- <div class="picture"></div> -->

    <div class="detail">
      <div class="item" >
        <span class="icon"style="font-size: 1.4rem;">Type name: </span>
        <span class="name" style="width:unset;font-size: 1.4rem;">{{ lessorInfo?.LandOwnershipTypeName }}</span>
      </div>
      <div class="item" >
        <span class="icon"style="font-size: 1.4rem;">Phone no.: </span>
        <span class="name" style="width:unset;font-size: 1.4rem;">{{ lessorInfo?.PhoneNo }}</span>
      </div>
      <div class="item" >
        <span class="icon"style="font-size: 1.4rem;">Survey Area: </span>
        <span class="name" style="width:unset;font-size: 1.4rem;">{{getSurveyArea(lessorInfo)}}</span>
      </div>
      <div class="item" >
        <span class="icon"style="font-size: 1.4rem;">Account no.: </span>
        <span class="name" style="width:unset;font-size: 1.4rem;">{{lessorInfo?.AccountNo}}</span>
      </div>
      <div class="item" >
        <span class="icon"style="font-size: 1.4rem;">Bank Name: </span>
        <span class="name" style="width:unset;font-size: 1.4rem;">{{lessorInfo?.BankName}}</span>
      </div>
      <div class="item" >
        <span class="icon"style="font-size: 1.4rem;">Email: </span>
        <span class="name" style="width:unset;font-size: 1.4rem;">{{ lessorInfo?.Email }}</span>
      </div>


        <span (click)="$event.stopImmediatePropagation()"><i class="ti-trash" (click)="onDelete(lessorInfo, i)"></i></span>


      <!-- <div class="item" >
        <span class="icon"> <i style="font-size: 1.4rem;"class="ti-calendar"></i></span>
        <span class="name" style="width:unset;">Lasfont-size: 1.4rem;t Payment on 12/03/2020</span>
      </div> -->
    </div>

    <div class="check_rep" (click)="$event.stopImmediatePropagation()" style="display:flex;justify-content: flex-end; margin: 1rem 0;">
      <button class="default_secondary-btn relatives" (click)="onRepresentative(lessorInfo)">See Representative</button>
    </div>
  </div>
  </div>


